@if (!currentUser) {
    <mat-toolbar [class.darkHeader]="selectedCommunity?.dark_header"
                 class="d-flex mat-elevation-z3 flex-space-between"
                 color="primary">
        <div>
            @if (companyImg && (!selectedCommunity?.login_page_top_logo_hidden || !this.isLogin)) {
                <button
                        [routerLinkActive]="'mat-accent'" [routerLink]="['/dashboard']"
                        aria-label="Feed"
                        class="logoBg logoBtn" mat-icon-button>
                    <img [src]="companyImg" class="companyImg ">
                </button>
            }
        </div>


        @if (showMenu()) {
            <button
                #menuOption="matMenuTrigger" [matMenuTriggerFor]="menu" aria-label="Menu"
                (menuOpened)="menuOption.menuOpen" (menuClosed)="menuOption.menuOpen"
                [style.color]="this.themeService.getReadableColor(loginNavColour? loginNavColour : loginNavColour|| primaryColor)"
                aria-label="Menu"
                class="tabletShow show"
                mat-icon-button matTooltip="More menu items">
                <i>
                    <svg viewBox="0 0 100 80" width="40" height="40"
                         [@openClose]="menuOption.menuOpen ? 'open' : 'closed'"
                         (@openClose.done)="onAnimationDone(menuOption.menuOpen)" [class.openedBurger]="menuOpen">
                        <rect width="100" height="10" rx="8"></rect>
                        <rect y="30" width="100" height="10" rx="8"></rect>
                        <rect y="60" width="100" height="10" rx="8"></rect>
                    </svg>
                </i>
            </button>
        }
        <mat-menu #menu="matMenu" class="styledMenu">
            @if (selectedCommunity?.terms_and_conditions) {
                <button [routerLink]="['/terms-and-conditions']" mat-menu-item>
                    <span>Terms & Conditions</span>
                </button>
            }
            @if (selectedCommunity?.privacy_policy) {
                <button [routerLink]="['/privacy-policy']" mat-menu-item>
                    <span>Privacy Policy</span>
                </button>
            }
            @for (item of listItems; track item) {
                @if (item.show_on_login_page) {
                    <button [routerLink]="['/info', item.id]" mat-menu-item>
                        {{ item.title }}
                    </button>
                }
            }
            @if (!loggedIn) {
                <button [routerLink]="['/login']" mat-menu-item>
                    <span>Login</span>
                </button>
            }
        </mat-menu>
    </mat-toolbar>
}
@if (currentUser) {
    <app-authview-header/>
}

<div [style.background-color]="this.backgroundColour" [style.background-image]="'url(' + backgroundImage + ')'"
     class="minFullHeight">
    <div [class.webview]="isWebView" class="control">
        <router-outlet #outlet="outlet"></router-outlet>
    </div>
    <app-footer></app-footer>
</div>


